
export default function CasesHero() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#10B981]/10 via-transparent to-transparent"></div>
      <div className="absolute top-20 right-0 w-96 h-96 bg-[#10B981]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#10B981]/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Conteúdo */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#10B981]/10 border border-[#10B981]/30 rounded-full px-4 py-2 mb-6">
              <i className="ri-verified-badge-fill text-[#10B981]"></i>
              <span className="text-[#10B981] text-sm font-medium whitespace-nowrap">Resultados Comprovados</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Casos de <span className="text-[#10B981]">Sucesso</span> Reais
            </h1>
            
            <p className="text-white/70 text-lg md:text-xl leading-relaxed mb-8">
              Conheça as histórias de empresas que transformaram seu atendimento e multiplicaram seus resultados com a IA da NeuroAgents.
            </p>
            
            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#10B981]/20 rounded-xl">
                  <i className="ri-building-2-line text-[#10B981] text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-white">500+</p>
                  <p className="text-white/60 text-sm whitespace-nowrap">Empresas Atendidas</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#10B981]/20 rounded-xl">
                  <i className="ri-line-chart-line text-[#10B981] text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-white">127%</p>
                  <p className="text-white/60 text-sm whitespace-nowrap">Crescimento Médio</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#10B981]/20 rounded-xl">
                  <i className="ri-star-fill text-[#10B981] text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-white">4.9/5</p>
                  <p className="text-white/60 text-sm whitespace-nowrap">Satisfação</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Card de Destaque */}
          <div className="relative">
            <div className="bg-gradient-to-br from-[#10B981] to-[#059669] rounded-3xl p-8 shadow-2xl shadow-[#10B981]/20">
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-arrow-up-line text-black text-2xl"></i>
                <span className="text-black/70 text-sm font-medium whitespace-nowrap">Resultado Médio</span>
              </div>
              <p className="text-7xl md:text-8xl font-bold text-black mb-2">127%</p>
              <p className="text-black/80 text-lg">de aumento no faturamento dos nossos clientes</p>
              
              <div className="mt-8 pt-6 border-t border-black/20">
                <div className="flex items-center gap-4">
                  <div className="flex -space-x-3">
                    <img src="https://public.readdy.ai/ai/img_res/0ff1fb8a05329ed3d08ff466c05d1e5e.jpg" alt="" className="w-10 h-10 rounded-full border-2 border-[#10B981] object-cover" />
                    <img src="https://readdy.ai/api/search-image?query=Professional%20Brazilian%20woman%20headshot%20portrait%20clean%20background%20confident%20smile&width=48&height=48&seq=avatar2&orientation=squarish" alt="" className="w-10 h-10 rounded-full border-2 border-[#10B981] object-cover" />
                    <img src="https://readdy.ai/api/search-image?query=Professional%20Brazilian%20man%20headshot%20portrait%20clean%20background%20confident%20smile&width=48&height=48&seq=avatar3&orientation=squarish" alt="" className="w-10 h-10 rounded-full border-2 border-[#10B981] object-cover" />
                    <div className="w-10 h-10 rounded-full border-2 border-[#10B981] bg-black flex items-center justify-center text-white text-xs font-bold">+497</div>
                  </div>
                  <p className="text-black/80 text-sm">Empresários satisfeitos</p>
                </div>
              </div>
            </div>
            
            {/* Badge flutuante */}
            <div className="absolute -bottom-4 -left-4 bg-black border border-white/10 rounded-2xl p-4 shadow-xl">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-[#10B981]/20 rounded-xl">
                  <i className="ri-time-line text-[#10B981] text-lg"></i>
                </div>
                <div>
                  <p className="text-white font-bold whitespace-nowrap">30 dias</p>
                  <p className="text-white/60 text-xs whitespace-nowrap">Tempo médio de resultado</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
